<template>
  <div class="m-newage">
    <template v-if="!loading">
      <div class="m-newage__hero" v-observe-visibility="observeVisibilitySettings(0, 'Header')">
        <div class="m-newage__hero__logo"></div>
        <div class="m-newage__hero__description">
          Step into a New Age of MapleStory with 6th Job&nbsp;skills, enhanced 5th&nbsp;Job abilities, and the
          new&nbsp;Hexa&nbsp;Matrix!
        </div>
        <div class="m-newage__hero__play" @click="playFree"><span>Play Free</span></div>
        <a
          href="https://maplestory.nexon.net/news/86907/v-246-new-age-6th-job-patch-notes"
          target="_blank"
          class="m-newage__hero__patch"
          @click="
            clickTracking({
              interaction: 'link_click',
              sectionNumber: 0,
              sectionName: 'Header',
              sectionContent: 'v.246 Patch Notes',
            })
          "
          >Go to v.246 Patch Notes!</a
        >
      </div>

      <div class="m-newage__content">
        <!-- <div
          class="m-newage__content__section m-newage__content__section-1"
          v-observe-visibility="observeVisibilitySettings(1, 'Journey Toward 6th Star')"
        >
          <div class="m-newage__content__section__image" />
          <div class="m-newage__content__section__title">Journey Toward the Sixth Star Event</div>
          <div class="m-newage__content__section__text">
            6th Job is nearly here, but there's still one chapter of the Journey Toward the Sixth Star Event left to
            complete! Join us in MapleStory in the days before&nbsp;the update arrives to claim the STAR Title Coupon
            and Starlight Energy Chair!
          </div>
          <div class="m-newage__content__section__text">
            Learn more in the
            <a
              href="https://maplestory.nexon.net/news/86745"
              target="_blank"
              @click="
                clickTracking({
                  interaction: 'link_click',
                  sectionNumber: 1,
                  sectionName: 'Journey Toward 6th Star',
                  sectionContent: 'Chapter VI Event Post',
                })
              "
              @click.middle="
                clickTracking({
                  interaction: 'link_click',
                  sectionNumber: 1,
                  sectionName: 'Journey Toward 6th Star',
                  sectionContent: 'Chapter VI Event Post',
                })
              "
              >Sixth Star Chapter VI Event Post!</a
            >
          </div>
        </div> -->

        <div
          class="m-newage__content__section m-newage__content__section-2"
          v-observe-visibility="observeVisibilitySettings(2, '6th Job and Hexa', 0.08)"
        >
          <div class="m-newage__content__section__divider"></div>
          <!-- section 2-1 -->
          <div class="m-newage__content__section m-newage__content__section-2-1">
            <div class="m-newage__content__section__title">6th Job and the Hexa Matrix</div>
            <div class="m-newage__content__section__description">Arrives on November 28</div>
            <div class="m-newage__content__section__text">
              As the boundary between Maple World and Grandis is sundered, a new form of Erda has been unleashed. Taming
              this new power will do more than save the goddesses of the two worlds: it will unlock skills never seen
              before in either land.
            </div>
            <div class="m-newage__content__section__text">
              6th Job Advancement will become available at Lv.&nbsp;260, with completion of the "[Convergence] True
              Form" quest.
            </div>
            <div class="m-newage__content__section__image" />
          </div>

          <!-- section 2-2 -->
          <div class="m-newage__content__section m-newage__content__section-2-2">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__subtitle">Hexa Skill Matrix</div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix will allow you to improve the skills that you've been relying on for years, granting
                them brand new effects! Gain new strength as you infuse this&nbsp;power into your entire arsenal of
                abilities!
              </div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix allows you to unlock and slot in a variety of nodes. These range from
                <span>Skill Nodes</span> that feature the unstoppable 6th Job skills, <span>Mastery Nodes</span> which
                greatly enhance or outright replace your 4th Job skills, and <br />
                <span>Boost Nodes</span> to give your 5th Job skills more punch.
              </div>
              <div class="m-newage__content__section__text">
                This is not the final form of the Hexa Matrix, with more nodes and more slots arriving in
                future&nbsp;updates!
              </div>
            </div>
            <div class="m-newage__content__section__right">
              <div class="m-newage__content__section__image" />
            </div>
          </div>

          <!-- section 2-3 -->
          <div class="m-newage__content__section m-newage__content__section-2-3">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__image" />
            </div>
            <div class="m-newage__content__section__right">
              <div class="m-newage__content__section__subtitle">Hexa Stat Matrix</div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix empowers you as well as your skills, with dynamic bonuses to your preferred stats right
                at your fingertips!
              </div>
              <div class="m-newage__content__section__text">
                A Hexa Stat Node allows you to grant a bonus to three stats of your choice: one primary gaining the
                biggest increase along with two secondary stats. Each time you level up these nodes, one of the chosen
                stats will be enhanced, making you even stronger.
              </div>
              <div class="m-newage__content__section__text">
                One Hexa Stat Node will be available when the New Age update arrives, with more nodes to come in future
                updates.
              </div>
            </div>
          </div>

          <!-- section 2-4 -->
          <div class="m-newage__content__section m-newage__content__section-2-4">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__subtitle">6th Job Skills</div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix can provide many abilities for your characters, but the most potent of them all are the
                new 6th Job skills. With a different skill for&nbsp;each class, these abilities will make you
                briefly&nbsp;invulnerable as you annihilate anything in your way. Check out the 6th Job skills video for
                a&nbsp;preview!
              </div>
            </div>
            <div class="m-newage__content__section__right">
              <div
                class="m-newage__content__section__image m-newage__content__section__image--video"
                @click="openModal('vfKP8EaAkvE')"
              />
            </div>
          </div>

          <!-- section 2-5 -->
          <div class="m-newage__content__section m-newage__content__section-2-5">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__image m-newage__content__section__image-1" />
              <div class="m-newage__content__section__image m-newage__content__section__image-2" />
            </div>
            <div class="m-newage__content__section__right">
              <div class="m-newage__content__section__subtitle">Sol Erda: The Sixth Power</div>
              <div class="m-newage__content__section__text">
                The energy of the Hexa Matrix might be beyond compare, but that power does not come without a price. By
                activating the matrix, you'll be able to claim Sol Erda Energy from bosses throughout Maple World.
                Collected energy will form Sol Erda when enough are gathered, and can be used in the Hexa Matrix
                to&nbsp;upgrade Hexa Skill and Stat Nodes.
              </div>
            </div>
          </div>
        </div>

        <!-- section 3 -->
        <div
          class="m-newage__content__section m-newage__content__section-3"
          v-observe-visibility="observeVisibilitySettings(3, 'Identisk')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">Identisk Exploration</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            The frosty island of Iden and the sun-kissed isle of Tisk have collided to form a new land mass, but with
            one mysterious consequence: The divine blessing over Iden has faded. Explore Identisk Island in this
            limited-time event during the New Age update to seek out this blessing and earn a wealth of special rewards!
          </div>
          <div class="m-newage__content__section__image" />
        </div>

        <!-- section 4 -->
        <div
          class="m-newage__content__section m-newage__content__section-4"
          v-observe-visibility="observeVisibilitySettings(4, 'Hyper Burn')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">Hyper Burn to Lv. 260!</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            Hyper Burning and the Burning World are back for another round, and this time the fires burn even hotter!
            Level up to Lv. 260 with massive EXP bonuses and bonus levels gained every time you level up, and climb
            towards the 6th Job on a brand new character!
          </div>
          <div class="m-newage__content__section__image" />
        </div>

        <!-- section 5 -->
        <div
          class="m-newage__content__section m-newage__content__section-5"
          v-observe-visibility="observeVisibilitySettings(5, 'Better Maple')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">More Changes for a Better Maple</div>
          <div class="m-newage__content__section__description">Available Now!</div>

          <div class="m-newage__content__section__images-wrapper">
            <div class="m-newage__content__section__image m-newage__content__section__image-1" />
            <div class="m-newage__content__section__image m-newage__content__section__image-2" />
            <div class="m-newage__content__section__image m-newage__content__section__image-3" />
          </div>

          <div class="m-newage__content__section__text">
            <div class="m-newage__content__section__text__highlight">Arcane River and Grandis Revamp</div>
            More EXP in Arcane River Daily Quests and lowered Sacred Power requirements!
          </div>

          <div class="m-newage__content__section__text">
            <div class="m-newage__content__section__text__highlight">Tower of Oz Witch Shop Update</div>
            Earn Tower of Oz Points in the Tower of Oz to spend in the Tower of Oz Witch Shop!
          </div>

          <div class="m-newage__content__section__text">
            <div class="m-newage__content__section__text__highlight">Level Up Adjustments</div>
            Level from Lv. 210 - 299 faster than ever with a reduced EXP curve!
          </div>

          <div class="m-newage__content__section__more">And More!</div>
        </div>

        <!-- section 6 -->
        <div
          class="m-newage__content__section m-newage__content__section-6"
          v-observe-visibility="observeVisibilitySettings(6, 'Coming Soon')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">Coming Soon on December 13</div>
          <div class="m-newage__content__section__image" />

          <div class="m-newage__content__section__text-title">
            The New Age continues in December, with even more challenges!
          </div>
          <div class="m-newage__content__section__text">
            <span>New Zone - Carcion:</span> Explore a new zone for high-level Maplers where an ancient god slumbers,
            and a great foe seeks its power...
          </div>
          <div class="m-newage__content__section__text">
            <span>Battleship Arteria:</span> A sinister warship is invading Maple World in this new high-level zone.
          </div>
          <div class="m-newage__content__section__text">
            <span>Abyssal Expedition:</span> A new expedition is setting out and they need you to lead a team of mighty
            warriors to explore the new land of Minar!
          </div>
          <div class="m-newage__content__section__text">
            <span>New Difficulties for Kaling and Kalos the&nbsp;Guardian:</span> Challenge two of our newest bosses on
            Easy, Chaos, and Extreme difficulties and claim new rewards!
          </div>
          <div class="m-newage__content__section__more">And More!</div>
        </div>
      </div>

      <Footer
        color="#5bd1ef"
        hoverColor="#ffffff"
        backgroundColor="#5f1f97"
        v-observe-visibility="observeVisibilitySettings(7, 'Footer')"
        @go-to-main-click="
          clickTracking({
            interaction: 'link_click',
            sectionNumber: 7,
            sectionName: 'Footer',
            sectionContent: 'Main Site',
          })
        "
        @link-click="
          (name) =>
            clickTracking({
              interaction: 'link_click',
              sectionNumber: 7,
              sectionName: 'Footer',
              sectionContent: name,
            })
        "
      />
    </template>

    <transition name="modal" appear @after-leave="afterModalClose">
      <aside
        v-if="showModal"
        ref="modal"
        class="m-newage__modal"
        tabindex="-1"
        @keyup.esc="closeModal"
        @click.self="closeModal"
      >
        <dialog open class="m-newage__modal__dialog">
          <div class="m-newage__modal__dialog__close" @click.self="closeModal" />
          <!-- :src="`https://www.youtube.com/embed/${youtubeId}?playlist=${youtubeId}&loop=1&rel=0&mute=1&autoplay=1`" -->
          <iframe
            width="100"
            height="100"
            :src="`https://www.youtube.com/embed/${youtubeId}?mute=1&autoplay=1`"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;fullscreen;"
          />
        </dialog>
      </aside>
    </transition>
  </div>
</template>

<script>
import Util from '@/services/browser/Util'
import Cookie from '@/services/browser/Cookie'
import Responsive from '@/services/browser/Responsive'
import Footer from '@/components/microsites/Footer.vue'
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import '@/assets/scss/microsites/newAge/newAge.scss'

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  name: 'Microsite New Age',
  components: {
    Footer,
  },
  props: {},
  data() {
    return {
      loading: true,
      showModal: false,
      youtubeId: '',
    }
  },
  mounted() {
    Responsive.init()
    setTimeout(() => {
      // wait for the responsive init
      this.loading = false

      window.dataLayer.push({
        pageType: 'Microsite',
        micrositeName: 'New Age',
        micrositePhase: '1-1',
      })
    }, 210)
    Cookie.set('maplenewage', 'true')
  },
  methods: {
    playFree() {
      Util.playFree()
      this.clickTracking({
        interaction: 'button_click',
        sectionNumber: 0,
        sectionName: 'Header',
        sectionContent: 'Play Free CTA',
      })
    },
    observeVisibilitySettings(id, name, threshold = 0.2) {
      return {
        callback: (isVisible) => (isVisible ? this.viewTracking({ id, name }) : null),
        intersection: { threshold: threshold },
        throttle: 1000,
        once: true,
      }
    },
    clickTracking({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) {
      window.dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: interaction,
        micrositeSectionNumber: sectionNumber,
        micrositeSectionName: sectionName,
        micrositeSectionContent: sectionContent,
        ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
      })
    },
    viewTracking({ id, name }) {
      window.dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: 'section_view',
        micrositeSectionNumber: id,
        micrositeSectionName: name,
      })
    },

    openModal(youtubeId) {
      this.youtubeId = youtubeId
      this.showModal = true
      if (
        window.innerWidth &&
        document.body &&
        document.body.clientWidth &&
        window.innerWidth !== document.body.clientWidth
      ) {
        document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`
      }
      document.body.classList.add('modal-active')
      this.$nextTick(() => {
        this.$refs.modal.focus()
      })

      this.clickTracking({
        interaction: 'button_click',
        sectionNumber: 2,
        sectionName: '6th Job and Hexa',
        sectionContent: '6th Job Skills Video',
      })
    },
    closeModal() {
      this.showModal = false
    },

    afterModalClose() {
      document.body.style.paddingRight = ''
      document.body.classList.remove('modal-active')
    },
  },
})
</script>

<style lang="scss" scoped>
.modal-enter-active {
  animation: slide-move 0.3s ease-in;
}
.modal-leave-active {
  animation: slide-move 0.4s reverse;
}

@keyframes slide-move {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
